var glicko2 = require("glicko2");

// If you change this, remember to change it both in the app and in the marketing website (i.e. leaderboard)
var settings = {
  // tau : "Reasonable choices are between 0.3 and 1.2, though the system should
  //      be tested to decide which value results in greatest predictive accuracy."
  tau: 0.5,
  // rating : default rating
  rating: 1500,
  //rd : Default rating deviation
  //     small number = good confidence on the rating accuracy
  rd: 200,
  //vol : Default volatility (expected fluctation on the player rating)
  vol: 0.06
};
var ranking = new glicko2.Glicko2(settings);

// If you change this, remember to change it both in the app and in the marketing website (i.e. leaderboard)
const userGlickoHistoryFromTrials = trials => {
  const user = ranking.makePlayer();
  return [
    user.getRating(),
    ...trials.map(trial => {
      const exercise = ranking.makePlayer(user.getRating());
      const outcome = trial.isCorrect ? 1 : 0;
      ranking.updateRatings([[user, exercise, outcome]]);
      return Math.round(user.getRating());
    })
  ];
};

// If you change this, remember to change it both in the app and in the marketing website (i.e. leaderboard)
const getGlicko = trials => userGlickoHistoryFromTrials(trials);

export { userGlickoHistoryFromTrials, getGlicko };
